import './back-to-top.scss';

class BackToTop {
    constructor ($element) {
        this.$backToTop = $element;
        this.$backToTopLink = this.$backToTop.querySelector('a');
        this.showButtonTimer = null;
    }

    initialize () {
        this.setEvents();
        this.checkButton();
    }

    checkButton () {
        if (window.scrollPosition >= window.innerHeight / 2) {
            this.$backToTop.classList.add('back-to-top--visible');
        } else {
            this.$backToTop.classList.remove('back-to-top--visible');
        }
    }

    setEvents () {
        window.eventScroller.customFunctions.push(() => {
            this.checkButton();
        });
    }
}

export { BackToTop };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $backToTop = $context.querySelector('[data-backtotop="root"]');
        if ($backToTop) {
            const backToTop = new BackToTop($backToTop);
            backToTop.initialize();
        }
    }
});
